/* eslint-disable import/prefer-default-export */
import config from './config';

// Make sure to READ THE DOCS (in the `docs` directory) before adding a feature toggle.
// Thanks in advance!

export const isLogRocketEnabled = () => config.LOG_ROCKET_ENABLED;
